import { render, staticRenderFns } from "./SVGAdminProjects.vue?vue&type=template&id=4937bec2&scoped=true&"
import script from "./SVGAdminProjects.vue?vue&type=script&lang=js&"
export * from "./SVGAdminProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4937bec2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4937bec2')) {
      api.createRecord('4937bec2', component.options)
    } else {
      api.reload('4937bec2', component.options)
    }
    module.hot.accept("./SVGAdminProjects.vue?vue&type=template&id=4937bec2&scoped=true&", function () {
      api.rerender('4937bec2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGAdminProjects.vue"
export default component.exports